import * as React from 'react';
import request  from '@/server/request';
import config from '@/server/config';
import { parse } from 'query-string';

export default class PurchaseOrderDetail extends React.Component<any, any> {
  public constructor(props: any) {
    super(props);
    this.state = {
      id: parse(this.props.location.search).id || '',
      info: {},
      list: [],
      toggleVisible: false
    };
  }

  public componentDidMount() {
    this.getData();
  }

  public render() {
    const { info, list, toggleVisible } = this.state;
    return (
      <div className="page-gray">
        <div className="bjDetail">
          <h2>采购单流水号：{info.stItemInfoId}</h2>
          <div className="bjDetail-list">
            <h3>{info.stBreed} {info.stGrade}</h3>
            <p><b>报价类型</b><em>{info.offerTypeValue}</em></p>
            <p><b>报价模式</b><em>{info.offerModeValue}</em></p>
            <p><b>产品分类</b><em>{info.mcProductPlatCategoryName}</em></p>
            <p><b>应用领域</b><em>{info.use}</em></p>
            {
              toggleVisible ?
              <div className="toggle-content">
                <p><b>品质要求</b><em>{info.requirementsQuality}</em></p>
                <p><b>生产商</b><em>{info.stFactory}</em></p>
                <p><b>包装要求</b><em>{info.packagedForm}</em></p>
                <p><b>采购数量</b><em>{info.stNumber}{info.stUnitStr}</em></p>
                <p><b>交货地点</b><em>{info.stAreaProvince}{info.stAreaCity}{info.stAreaCountry}{info.stArea}</em></p>
                <p><b>交货日期</b><em>{info.deliveryDateDesc}</em></p>
                {
                  info.offerType === 2 ? <p><b>结算方式</b><em>{info.clearingForm}</em></p> : null
                }
                {
                  info.offerType === 2 ? <p><b>竞价限购</b><em>{info.biddingStartTime} 至 {info.biddingEndTime}</em></p> : <p><b>限时报价</b><em>{info.quoteStartTime} 至 {info.quoteEndTime}</em></p>
                }
                <p><b>备注</b><em>{info.remark}</em></p>
              </div> : null
            }
          </div>
          {
            list.length > 0 ? <span className="all" onClick={this.toggleAction.bind(this)}>{toggleVisible ? '收起' : '展开'}</span> : <div className="kefu"><span>客服电话：4009300360</span><a href="tel:4009300360"><img src={require('../../../assets/images/dhicon.png')} /></a></div>
          }
        </div>
        {
          list.length > 0 ?
        <div className="gyslist">
          <h2>供应商报价列表（{list.length}）</h2>
          <ul>
            {
              list.map((v: any, k: any) => {
                return (
                <li key={v.spPriceItemId}>
                  {
                    v.askNotReadStatus ?
                    <b className="iconfontBG">
                      <i className="icon-NEW iconfont"></i>
                    </b> : null
                  }
                  <div className="gys-gs">
                    <h3>
                      <span>{v.companyName}</span>
                      <img src={v.sellerGradeIcon} />
                    </h3>
                    <i>{v.spPriceTimeValue}</i>
                  </div>
                  <p><b>生产商</b><em>{v.factory}</em></p>
                  <p><b>型号</b><em>{v.grade}</em></p>
                  <p><b>单价</b><em>{v.price}元</em></p>
                  {
                    v.productLink ? <p>
                       <b>产品链接</b>
                        <em><a href={v.productLink}>{v.productLink}</a>
                        </em></p>
                       : null
                    }
                  <p>
                    <b>联系人</b>
                    <strong className="kefu">
                      <i>{v.memberTrueName} {v.mobile}</i>
                      <a href={"tel:" + (info.mmobile || v.phone)} onClick={() => this.takePhone(v.spPriceId, k)}>
                        <img src={require('../../../assets/images/dhicon.png')} />
                      </a>
                    </strong>
                    <span className={(v.isContact === 0 || !v.isContact) ? 'red' : ''}>{v.isContactValue || '未联系'}</span>
                  </p>
                </li>
                )
              })
            }
            </ul>
        </div>
        : null}
      </div>
    )
  }

  // 获取页面数据
  private async getData() {
    const r = await request({
        method: 'get',
        data: {
          stItemInfoId: this.state.id,
          allowAllSource: true
        },
        url: `${config.API2}bjt/st/details`,
    });

    if (r.code === 1) {
      this.setState({
        info: r.obj.stInfo,
        list: r.obj.spPriceList,
        toggleVisible: r.obj.spPriceList.length === 0
      }, () => {
        this.removeNewPoint();
      });
    }
  }

  // 展开隐藏
  private toggleAction() {
    this.setState((state: any) => {
      return {
        toggleVisible: !state.toggleVisible
      }
    });
  }

  /**
   * [ 拨打电话 ]
   * @param id {Number} 联系采购商id
   * @param k {any} 索引
   */
  private async takePhone(id: Number, k: any) {
    const r = await request({
        method: 'get',
        data: {
          spPriceId: id
        },
        url: `${config.API2}bjt/st/contact`,
    });

    if (r.code === 1) {
      const _list = [...this.state.list];
      _list[k].isContact = 1;
      _list[k].isContactValue = '已联系';
      this.setState({
        list: _list
      });
    }
  }

  // 消除红点
  private async removeNewPoint() {
    const ids = this.state.list.filter((v: any) => {
      return v.askNotReadStatus;
    }).map((v: any) => v.spPriceItemId).join(',');

    if (ids !== '') {
      request({
        url: `${config.MALLAPI}api/wshop/ask/remove-status`,
        method: 'post',
        data: {
          type: 1,
          recordType: 8,
          dataId: ids
        }
      });
    }
  }
}
